import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';

import { Observable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { RouterModule } from '@angular/router';
// Components
import { SwiperModule } from 'swiper/angular';

import {
  Swiper,
  Navigation,
  Pagination,
  FreeMode,
  A11y,
  Controller,
  Thumbs,
  HashNavigation,
  Autoplay,
} from 'swiper';
import { RemoveIconComponent } from '../../../shared/components/icons/generated/remove/remove.component';
import { AkitaRouterService } from '@app/akita/router/state/router.service';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { CheckBlueIconComponent } from '../../../shared/components/icons/generated/check-blue/check-blue.component';
import { LogoPopsyIconComponent } from '../../../shared/components/icons/generated/logo-popsy/logo-popsy.component';
import { ToolDarkIconComponent } from '../../../shared/components/icons/generated/tool-dark/tool-dark.component';
import { CertifiedDarkIconComponent } from '../../../shared/components/icons/generated/certified-dark/certified-dark.component';
import { WarrantyDarkIconComponent } from '../../../shared/components/icons/generated/warranty-dark/warranty-dark.component';
import { ReturnDarkIconComponent } from '../../../shared/components/icons/generated/return-dark/return-dark.component';

Swiper.use([
  Navigation,
  Pagination,
  FreeMode,
  A11y,
  Controller,
  Thumbs,
  HashNavigation,
  Autoplay,
]);

@Component({
  selector: 'app-benefits-banner',
  templateUrl: './benefits-banner.template.html',
  styleUrls: ['./benefits-banner.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    SwiperModule,
    RemoveIconComponent,
    CheckBlueIconComponent,
    LogoPopsyIconComponent,
    ToolDarkIconComponent,
    CertifiedDarkIconComponent,
    WarrantyDarkIconComponent,
    ReturnDarkIconComponent,
  ],
})
export class BenefitsBannerComponent {
  @Input() public country?: string | null;

  public thumbsSwiper: any;

  public language: string;

  public readonly biggerThan$: Observable<ScreenSizeInfoState>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly translateService: TranslocoService,
    private readonly akitaRouterService: AkitaRouterService,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.language = this.translateService.getActiveLang();
  }

  public renderCustom(): any {
    const names = [];
    const list = document.getElementsByClassName('.swiper-wrapper .swiper-slide');

    for (const item of list) {
      names.push(item.attributes.getNamedItem('name'));
    }

    let text = '<ul class="swiper-pagination">';
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    for (let i = 1; i <= 3; i++) {
      text += `<li class="swiper-pagination-bullet">${names[i]}</li>`;
    }
    text += '</ul>';

    console.log(text);
    return text;
  }

  public navigateToAboutUs(): void {
    const fragments = this.akitaRouterQuery.homeUrlFragment;
    console.log('navigate to about us');
    fragments.push('about-us');
    this.akitaRouterService.navigate(fragments);
  }
}
